import { mergeStyleSets, useTheme } from "@fluentui/react";

export const useStyles = (maxHeight?: number) => {
  const theme = useTheme();

  return mergeStyleSets({
    pickerList: {
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      minHeight: '72px',
      maxHeight: maxHeight ? `${maxHeight}px` : '250px',
    },
    scrollable: {
      overflowY: 'auto',
      overflowX: 'hidden',
      height: '100%',
      border: `1px solid ${theme.palette.neutralQuaternary}`,
      padding: '4px 0',
    },
    noItemMessage: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexGrow: 1,
      height: '100%',
      color: theme.palette.neutralTertiaryAlt,
      border: `1px solid ${theme.palette.neutralQuaternary}`,
    }
  })
}
